import React from 'react';
import { Link } from 'react-router-dom';
import equal from 'fast-deep-equal/es6/react';
import { IIncidentStatus } from '../../../../../core/interfaces/IIncidents';

interface ActionButtonsProps {
  selectedStatus: IIncidentStatus[];
  showAction: boolean;
  checked: string[];
  onToggleActions: (event: React.MouseEvent) => void;
  onAcknowledge: () => void;
  onResolve: () => void;
  onReassign?: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  selectedStatus,
  showAction,
  checked,
  onToggleActions,
  onAcknowledge,
  onResolve,
  onReassign,
}) => {
  const showActionsDropdown =
    equal(selectedStatus, ['triggered']) || equal(selectedStatus, ['acknowledged']);

  if (!showActionsDropdown) {
    return (
      <Link to="/incident/create">
        <button className="small-button-inverse" style={{ marginLeft: 20, fontSize: 16 }}>
          +
        </button>
      </Link>
    );
  }

  return (
    <div style={{ position: 'relative', display: 'inline' }}>
      <button onClick={onToggleActions} className="filter-button-small-design">
        Actions &nbsp;&nbsp;
        <i className={'fa fa-angle-' + (showAction ? 'up' : 'down')} />
      </button>

      {showAction && (
        <div className="filter-drop-left">
          <div
            onClick={onAcknowledge}
            className={
              'bulk-action-buttons ' +
              (checked.length && equal(selectedStatus, ['triggered'])
                ? 'bulk-action-buttons-hover'
                : 'bulk-action-buttons-disabled')
            }
          >
            Acknowledge
          </div>
          <div
            onClick={onResolve}
            className={
              'bulk-action-buttons ' +
              (checked.length &&
              (equal(selectedStatus, ['triggered']) || equal(selectedStatus, ['acknowledged']))
                ? 'bulk-action-buttons-hover'
                : 'bulk-action-buttons-disabled')
            }
          >
            Resolve
          </div>
          {onReassign && (
            <div
              onClick={onReassign}
              className={
                'bulk-action-buttons ' +
                (checked.length &&
                (equal(selectedStatus, ['triggered']) || equal(selectedStatus, ['acknowledged']))
                  ? 'bulk-action-buttons-hover'
                  : 'bulk-action-buttons-disabled')
              }
            >
              Reassign
            </div>
          )}
        </div>
      )}

      <Link to="/incident/create">
        <button className="small-button-inverse" style={{ marginLeft: 20, fontSize: 16 }}>
          +
        </button>
      </Link>
    </div>
  );
};

export default ActionButtons;
